
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div class="giga-action_links">
    <div class="giga-action_row">
      <b-button
        :to="{ name: 'SimulationsOverview', params: { id: id } }"
        :class="[{ activeTab: $route.name === 'SimulationsOverview' }]"
        pill
      >
        {{ $t("overview") }}</b-button
      >
      <b-button
        :to="{ name: 'SimulationsOperations', params: { id: id } }"
        :class="[{ activeTab: $route.name === 'SimulationsOperations' }]"
        pill
      >
        {{ $t("operations_list") }}</b-button
      >
      <b-button
        :to="{ name: 'SimulationsDocuments', params: { id: id } }"
        :class="[{ activeTab: $route.name === 'SimulationsDocuments' }]"
        pill
      >
        {{ $t("documents") }}</b-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "ActionLink",
  props: ["id"],
};
</script>
